// Copyright ©️ 2026 eVolve MEP, LLC

import { Navigate, type NavigateProps } from 'react-router';

import { moduleRoute } from 'app/Layout/NavBar/globalNavigationMenu';
import type { ShopNavigationRoute } from 'app/ModuleRoutes';

type Props = Omit<NavigateProps, 'to'> & {
  to: ShopNavigationRoute;
};

export const ShopNavigate = ({ to, ...props }: Props) => <Navigate {...props} to={`/${moduleRoute}/${to}`} />;
